import { init } from '@sentry/capacitor'
import { init as initVue } from '@sentry/vue'
import { type App } from 'vue'

export default function (vueApp: App) {
  const { sentry, version, name } = useRuntimeConfig().public
  if (sentry.dsn) {
    init(
      {
        app: vueApp,
        dsn: sentry.dsn,
        environment: sentry.env,
        enabled: Boolean(sentry.env),
        debug: process.env.NODE_ENV === 'development',
        initialScope: {
          tags: {
            application: name,
            service: 'monito-apps',
            version,
          },
        },
        // vue options
        attachProps: true,
      },
      initVue,
    )
  }
}
